
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexXysIP8lCqJF96icRXu8PR0FqfqQOqlRF91VbO45KwIEMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/index.vue?macro=true";
import { default as contact_xdSs5QUqZj5A3B87xLVPpp3PS7W2rBrpWE0Ev6jW0EMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/contact.vue?macro=true";
import { default as doe_45meeJV31yDLli0A_9oNF_A22AI8h6kwSidX7SyUkvVLHpI0Meta } from "/home/tom/projects/ongehoord-ui-content/app/pages/doe-mee.vue?macro=true";
import { default as donerenMkHl0dU5mpHCN3a5T2iVu3wv6NRXrNPgdkIygLvfTbsMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/doneren.vue?macro=true";
import { default as sandboxtpFRRb2zRzF5_45lbuwW0IczG1__45V7TBIw8ZCDfYfVfxIMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/sandbox.vue?macro=true";
import { default as indexHun_01F5z_45sEjiXifF5XoY35L1dzK0jqBUEpGJEs_moMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/tools/index.vue?macro=true";
import { default as indexkBtQntVgX0Ikw66BMtTAgNJwNnWkLqnNARfCEiVbfQwMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/index.vue?macro=true";
import { default as index5Fqq8MBFwIstj_45Jrb6o6OljgKdJ0eZmXNJCd2ItabLMMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/index.vue?macro=true";
import { default as _91locationSlug_93WdSaxSFuylVpqxBtyFd_nICH9pO_bDjrRdAmhGurEWQMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/locaties/[locationSlug].vue?macro=true";
import { default as _91chapterName_93_iLn5KLvqIhTLNQFLE0YhQ4gLV_podPu8dimYMMmW14Meta } from "/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/hoofdstukken/[chapterName].vue?macro=true";
import { default as _91slug_93wTZqcY45us00m5_45LWaYoSef0YGqMIXv1vHOILT4v6ZYMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug].vue?macro=true";
import { default as image_45fetcherZCujwfWJPwxmdvQlVAfLdWa1We_451TGuykntugQyTqj8Meta } from "/home/tom/projects/ongehoord-ui-content/app/pages/tools/image-fetcher.vue?macro=true";
import { default as parse_45annotationsWf9nh9L2BWyCPqVBf0XY9d22h8fJ92qsVi6k_xSMLOEMeta } from "/home/tom/projects/ongehoord-ui-content/app/pages/tools/parse-annotations.vue?macro=true";
import { default as component_45stubh5stuVvPaLVOc25oqgMHSTHDTzxtKEt5wOutBsCAbiwMeta } from "/home/tom/projects/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_better-sqlit_ac6333106c0813e2703644621bc5c54b/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubh5stuVvPaLVOc25oqgMHSTHDTzxtKEt5wOutBsCAbiw } from "/home/tom/projects/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_better-sqlit_ac6333106c0813e2703644621bc5c54b/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___nl",
    path: "/",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/index.vue")
  },
  {
    name: "contact___nl",
    path: "/contact",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/contact.vue")
  },
  {
    name: "doe-mee___nl",
    path: "/doe-mee",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/doe-mee.vue")
  },
  {
    name: "doe-mee___en",
    path: "/en/doe-mee",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/doe-mee.vue")
  },
  {
    name: "doneren___nl",
    path: "/doneren",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/doneren.vue")
  },
  {
    name: "doneren___en",
    path: "/en/doneren",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/doneren.vue")
  },
  {
    name: "sandbox___nl",
    path: "/sandbox",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/sandbox.vue")
  },
  {
    name: "sandbox___en",
    path: "/en/sandbox",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/sandbox.vue")
  },
  {
    name: "tools___nl",
    path: "/tools",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/tools/index.vue")
  },
  {
    name: "tools___en",
    path: "/en/tools",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/tools/index.vue")
  },
  {
    name: "onderzoek___nl",
    path: "/onderzoek",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/index.vue")
  },
  {
    name: "onderzoek___en",
    path: "/en/onderzoek",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/index.vue")
  },
  {
    name: _91slug_93wTZqcY45us00m5_45LWaYoSef0YGqMIXv1vHOILT4v6ZYMeta?.name,
    path: "/onderzoek/:slug()",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug].vue"),
    children: [
  {
    name: "onderzoek-slug___nl",
    path: "",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/index.vue")
  },
  {
    name: "onderzoek-slug-locaties-locationSlug___nl",
    path: "locaties/:locationSlug()",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/locaties/[locationSlug].vue")
  },
  {
    name: "onderzoek-slug-hoofdstukken-chapterName___nl",
    path: "hoofdstukken/:chapterName()",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/hoofdstukken/[chapterName].vue")
  }
]
  },
  {
    name: _91slug_93wTZqcY45us00m5_45LWaYoSef0YGqMIXv1vHOILT4v6ZYMeta?.name,
    path: "/en/onderzoek/:slug()",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug].vue"),
    children: [
  {
    name: "onderzoek-slug___en",
    path: "",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/index.vue")
  },
  {
    name: "onderzoek-slug-locaties-locationSlug___en",
    path: "locaties/:locationSlug()",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/locaties/[locationSlug].vue")
  },
  {
    name: "onderzoek-slug-hoofdstukken-chapterName___en",
    path: "hoofdstukken/:chapterName()",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/onderzoek/[slug]/hoofdstukken/[chapterName].vue")
  }
]
  },
  {
    name: "tools-image-fetcher___nl",
    path: "/tools/image-fetcher",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/tools/image-fetcher.vue")
  },
  {
    name: "tools-image-fetcher___en",
    path: "/en/tools/image-fetcher",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/tools/image-fetcher.vue")
  },
  {
    name: "tools-parse-annotations___nl",
    path: "/tools/parse-annotations",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/tools/parse-annotations.vue")
  },
  {
    name: "tools-parse-annotations___en",
    path: "/en/tools/parse-annotations",
    component: () => import("/home/tom/projects/ongehoord-ui-content/app/pages/tools/parse-annotations.vue")
  },
  {
    name: component_45stubh5stuVvPaLVOc25oqgMHSTHDTzxtKEt5wOutBsCAbiwMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubh5stuVvPaLVOc25oqgMHSTHDTzxtKEt5wOutBsCAbiw
  },
  {
    name: component_45stubh5stuVvPaLVOc25oqgMHSTHDTzxtKEt5wOutBsCAbiwMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubh5stuVvPaLVOc25oqgMHSTHDTzxtKEt5wOutBsCAbiw
  }
]